"use strict";

define('rs/models/assignment.builder',['rs/models/abstract', 'rs/models/person', 'rs/models/group', 'rs/models/sponsor', 'rs/models/organization', 'rs/helper'], function (RSAbstractModel, Person, Group, Sponsor, Organization, RSHelper) {
  var RSAssignmentBuilder = RSAbstractModel.extend({
    properties: ['assignmentTypes', 'documentId', 'studyId', 'personAssignments', 'propertyAssignments', 'sponsorAssignments', 'organizationAssignments', 'groupAssignments'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      if (this.document) {
        this.setDocumentId(this.document.id);
      }
      if (this.study) {
        this.setStudyId(this.study.id);
      }
      if (!(this.getStudyId() || this.getDocumentId())) {
        throw new Error('You must initialize AssignmentBuilder with a document or study id');
      }
      this.clearAssignmentData();
    },
    addPerson: function addPerson(person, type, options) {
      options = options || {};
      this.getPersonAssignments().push({
        id: person ? person.id : null,
        groupId: person && options.groupId ? options.groupId : null,
        assignmentType: type
      });
      return this;
    },
    addProperty: function addProperty(value, type, options) {
      options = options || {};
      this.getPropertyAssignments().push({
        value: value,
        assignmentType: type
      });
      return this;
    },
    addOrganization: function addOrganization(organization, type, options) {
      options = options || {};
      this.getOrganizationAssignments().push({
        id: organization ? organization.id : null,
        assignmentType: type
      });
      return this;
    },
    addGroup: function addGroup(group, type, options) {
      options = options || {};
      this.getGroupAssignments().push({
        id: group ? group.id : null,
        assignmentType: type
      });
      return this;
    },
    addSponsor: function addSponsor(sponsor, type, options) {
      type = type || 'IRB_SPONSOR';
      options = options || {};
      this.getSponsorAssignments().push({
        id: sponsor ? sponsor.id : null,
        assignmentType: type
      });
      return this;
    },
    clearAssignmentData: function clearAssignmentData() {
      this.setPersonAssignments([]);
      this.setSponsorAssignments([]);
      this.setOrganizationAssignments([]);
      this.setPropertyAssignments([]);
      this.setGroupAssignments([]);
    },
    mapAssignmentType: function mapAssignmentType(assignments) {
      var that = this;
      return _.filter(assignments, function (assignment) {
        var typeDescription = assignment.assignmentType,
          typeObject = _.findWhere(that.getAssignmentTypes(), {
            description: typeDescription
          });
        if (typeObject) {
          assignment.assignmentTypeId = typeObject.id;
          delete assignment.assignmentType;
          return true;
        }
        return false;
      });
    },
    requestMakePersonAssignments: function requestMakePersonAssignments() {
      var assignments = this.getPersonAssignments();
      if (assignments.length) {
        return this.constructor.requestMakePersonAssignments(this.getDocumentId(), this.mapAssignmentType(assignments));
      }
    },
    requestMakeSponsorAssignments: function requestMakeSponsorAssignments() {
      var assignments = this.getSponsorAssignments();
      if (assignments.length) {
        return this.constructor.requestMakeSponsorAssignments(this.getDocumentId(), this.mapAssignmentType(assignments));
      }
    },
    requestMakePropertyAssignments: function requestMakePropertyAssignments() {
      var assignments = this.getPropertyAssignments();
      if (assignments.length) {
        return this.constructor.requestMakePropertyAssignments(this.getDocumentId(), this.mapAssignmentType(assignments));
      }
    },
    requestMakeOrganizationAssignments: function requestMakeOrganizationAssignments() {
      var assignments = this.getOrganizationAssignments();
      if (assignments.length) {
        return this.constructor.requestMakeOrganizationAssignments(this.getStudyId(), this.mapAssignmentType(assignments));
      }
    },
    requestMakeGroupAssignments: function requestMakeGroupAssignments() {
      var assignments = this.getGroupAssignments();
      if (assignments.length) {
        return this.constructor.requestMakeGroupAssignments(this.getDocumentId(), this.mapAssignmentType(assignments));
      }
    },
    requestApply: function requestApply() {
      var that = this;
      return Promise.resolve(this.constructor.requestAssignmentTypes()).tap(function (assignmentTypes) {
        that.setAssignmentTypes(assignmentTypes);
      }).then(function () {
        return that.requestMakePersonAssignments();
      }).then(function () {
        return that.requestMakeSponsorAssignments();
      }).then(function () {
        return that.requestMakePropertyAssignments();
      }).then(function () {
        return that.requestMakeOrganizationAssignments();
      }).then(function () {
        return that.requestMakeGroupAssignments();
      }).tap(function () {
        that.clearAssignmentData();
      });
    }
  }, {
    rootURI: '/rs/api/assignment/',
    routes: {
      'POST property/:$0': {
        fn: 'requestMakePropertyAssignments',
        jsonBody: true
      },
      'POST sponsor/document/:$0': {
        fn: 'requestMakeSponsorAssignments',
        jsonBody: true
      },
      'POST group/:$0': {
        fn: 'requestMakeGroupAssignments',
        jsonBody: true
      },
      'POST organization/study/:$0': {
        fn: 'requestMakeOrganizationAssignments',
        jsonBody: true
      },
      'POST person/document/:$0': {
        fn: 'requestMakePersonAssignments',
        jsonBody: true
      },
      'POST changeAnalyst/:$0/:$1': 'requestChangeAnalystAssignment',
      'GET type/person': 'requestFinderAssignmentTypes',
      'GET type': '_requestAssignmentTypes',
      'GET study/:$0': 'requestStudyAssignments',
      'GET document/:$0': 'requestAssignments',
      'GET document/:$0/:$1': 'requestAssignmentsByType'
    },
    parsers: {
      'study/:id': 'setupAssignments',
      'document/:id': 'setupAssignments'
    },
    types: ["DEPARTMENT_APPROVER", "INVESTIGATOR", "IRB_ANALYST", "IRB_BOARD", "IRB_CO_PRINCIPAL_INVESTIGATOR", "IRB_EXEMPT_REVIEWER", "IRB_EXEMPT_TYPE", "IRB_EXPEDITED_APPROVED", "IRB_FULL_APPROVED", "IRB_ORG_APPROVER", "IRB_ORGANIZATION", "IRB_REVIEW_TYPE", "IRB_REVIEWER", "IRB_REVIEWER_PRIMARY", "IRB_REVIEWER_SECONDARY", "IRB_SPONSOR", "PRIMARY_CONTACT", "PRINCIPAL_INVESTIGATOR"],
    values: {
      FULLBOARD: 'FULL',
      EXPEDITED: 'EXPEDITED',
      EXEMPT: 'EXEMPT',
      ANALYST: 'IRB_ANALYST',
      BOARD: 'IRB_BOARD'
    },
    getStudyAssignmentTypes: function getStudyAssignmentTypes() {
      return ["IRB_ANALYST", "IRB_ORG_APPROVER", "IRB_REVIEWER", "PRINCIPAL_INVESTIGATOR"];
    },
    getStudyAssignmentDisplayTypes: function getStudyAssignmentDisplayTypes() {
      return ['Analyst', 'Co-Principal Investigator', 'Investigator', 'Organization Approver', 'Primary Contact', 'Principal Investigator', 'Reviewer'];
    },
    getBoardConflictTypes: function getBoardConflictTypes() {
      return ["PRINCIPAL_INVESTIGATOR", "CO_PRINCIPAL_INVESTIGATOR", "PRIMARY_CONTACT", "INVESTIGATOR"];
    },
    getTypes: function getTypes() {
      return this.types || [];
    },
    getNameFromAssignmentTypeObject: function getNameFromAssignmentTypeObject(obj) {
      return obj.description;
    },
    requestAssignmentsMap: function requestAssignmentsMap(documentId) {
      return this.requestAssignments(documentId).bind(this).then(this.createAssignmentMap);
    },
    setupAssignments: function setupAssignments(assignments) {
      return _.map(assignments, this.setupAssignmentInstances, this);
    },
    setupAssignmentInstances: function setupAssignmentInstances(assignment) {
      if (assignment.person) {
        assignment.person = Person.model(assignment.person);
      }
      if (assignment.group) {
        assignment.group = Group.model(assignment.group);
      }
      if (assignment.sponsor) {
        assignment.sponsor = Sponsor.model(assignment.sponsor);
      }
      if (assignment.organization) {
        assignment.organization = Organization.model(assignment.organization);
      }
      if (assignment.property) {}
      return assignment;
    },
    getObjectFromAssignment: function getObjectFromAssignment(assignment) {
      var value = null;
      if (assignment.person) {
        value = assignment.person;
      } else if (assignment.organization) {
        value = assignment.organization;
      } else if (assignment.group) {
        value = assignment.group;
      } else if (assignment.sponsor) {
        value = assignment.sponsor;
      } else if (assignment.value) {
        value = assignment.value;
      }
      return value;
    },
    getTypeFromAssignment: function getTypeFromAssignment(assignment) {
      return assignment.assignmentType.description;
    },
    createAssignmentMap: function createAssignmentMap(assignments) {
      var types = this.getTypes(),
        mapping = {},
        len = assignments ? assignments.length : 0,
        assignment = null,
        type = null,
        i = 0;
      for (i = 0; i < types.length; i++) {
        mapping[types[i]] = [];
      }
      for (i = 0; i < len; ++i) {
        assignment = assignments[i], type = assignment.assignmentType.description;
        if (!mapping[type]) {
          mapping[type] = [];
        }
        mapping[type].push(assignment);
      }
      return mapping;
    },
    createAssignmentTypesMap: function createAssignmentTypesMap(assignmentTypes) {
      var map = {},
        len = assignmentTypes ? assignmentTypes.length : 0,
        i = 0;
      for (i = 0; i < len; ++i) {
        map[assignmentTypes[i].description] = assignmentTypes[i];
      }
      return map;
    },
    requestAssignmentTypes: function requestAssignmentTypes() {
      if (this.assignmentTypes) {
        return this.assignmentTypes;
      } else {
        return this._requestAssignmentTypes().bind(this).then(function (assignmentTypes) {
          this.assignmentTypesMap = this.createAssignmentTypesMap(assignmentTypes);
          return this.assignmentTypes = assignmentTypes;
        });
      }
    },
    getAssignmentType: function getAssignmentType(type) {
      return this.assignmentTypesMap[type];
    },
    requestPersonAssignmentTypes: function requestPersonAssignmentTypes() {
      return Promise.resolve(this.requestAssignmentTypes()).then(function (types) {
        return _.filter(types, function (type) {
          return type.finderType == 'Person';
        });
      });
    },
    requestOneAssignmentByType: function requestOneAssignmentByType() {
      return this.requestAssignmentsByType.apply(this, arguments).spread(function (assignment) {
        return assignment;
      });
    }
  });
  return RSAssignmentBuilder;
});

